<mat-table [dataSource]="data()" class="mat-elevation-z4 mt-3">
	@for (item of tableColumns; track item.id) {
		<ng-container [matColumnDef]="item.id">
			<mat-header-cell *matHeaderCellDef>{{ item.name }}</mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element[item.id] | priceCurrency: 'PLN' }}</mat-cell>
		</ng-container>
	}
	<mat-header-row *matHeaderRowDef="tableKeys"></mat-header-row>
	<mat-row *matRowDef="let row; columns: tableKeys"></mat-row>
</mat-table>
